import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const HomelessChartsDataContext = createContext();

const HomelessChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.STREET_SITUATION_HOMELESS,
            url: 'governanceroom/dashboard/unifiedregistry/street-situation/homeless'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  homeless: data?.indicators?.homeless ?? 0,
                  averageOfHomelessPerFamily:
                      data?.indicators?.averageOfHomelessPerFamily ?? 0,
                  percentageHomeless: data?.indicators?.percentageHomeless ?? 0
              },
              homelessAndReltativesContact:
                  data?.homelessAndReltativesContact ?? [],
              homelessCondiction: data?.homelessCondiction ?? [],
              permanenceTime: data?.permanenceTime ?? []
          }
        : {
              indicators: {
                  homeless: 0,
                  averageOfHomelessPerFamily: 0,
                  percentageHomeless: 0
              },
              homelessAndReltativesContact: [],
              homelessCondiction: [],
              permanenceTime: []
          };

    return (
        <HomelessChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </HomelessChartsDataContext.Provider>
    );
};

export default HomelessChartsDataProvider;
